import { UserRole } from "tm-shared/types";

export interface PointCreateCapabilities {
    canEditPartner: boolean;
}

export const getPointCreateCapabilities = (
    role: UserRole,
): PointCreateCapabilities => ({
    canEditPartner: role !== UserRole.Sv,
});
